<template>
  <NuxtLink
    :to="linkUrl"
    class="c-userCassette"
  >
    <div class="c-userCassetteInfo">
      <div class="c-userCassetteInfo_left">
        <div class="c-userCassetteInfo_icon">
          <CUserIconV2
            :file-path="user.resizableProfileIcon"
            :size="42"
            v-if="!isSkeleton"
          />
        </div>
        <div
          v-if="!isSimple"
          class="c-userCassetteInfo_label"
        >
          <div
            v-if="user.isPro"
            class="c-userCassetteInfo_certificationIcon"
          >
            <!--
              ProIcon.vueを使うとVirtual DOMとのアンマッチが生じるのでimgで対応
              aタグが入れ子になってしまうのが原因
            -->
            <img
              :src="$coconala.fileURL('/staticfiles/images/certification/pro/icon-outline.svg')"
              alt="PRO"
              loading="lazy"
            >
          </div>
          <div
            v-else-if="user.isCertificationDivination"
            class="c-userCassetteInfo_certificationIcon"
          >
            <img
              :src="$coconala.fileURL('/staticfiles/images/certification/divination/icon-outline.svg')"
              alt="占い"
              loading="lazy"
            >
          </div>
          <div
            class="c-userCassetteInfo_labelLevel"
            v-if="user.providerLevel.value > 0"
          >
            <img
              :src="$coconala.levelIconURL(user.providerLevel.value)"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="c-userCassetteInfo_right">
        <div class="c-userCassetteInfo_name">
          {{ $util.truncate(user.userName, 10) }}
        </div>
        <div class="c-userCassetteInfo_occupation">
          {{ user.occupation }}
        </div>
        <div
          v-if="!isSimple"
          class="c-userCassetteInfo_rating"
        >
          <div
            class="c-userCassetteInfoRating"
            v-if="user.averageRating"
          >
            <CoconalaIcon
              name="star"
              class="c-userCassetteInfoRating_star"
            />
            <span class="c-userCassetteInfoRating_score">
              {{ user.averageRating.toFixed(1) }}
            </span>
          </div>
          <div
            class="c-userCassetteInfoRating"
            v-else
          >
            <CoconalaIcon
              name="star"
              class="c-userCassetteInfoRating_star"
            /> -
          </div>
          <div
            class="c-userCassetteInfoPaidOrderCount"
            v-if="user.paidOrderCount > 0"
          >
            ({{ user.paidOrderCount }})
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>
<script>
import { mapState } from 'vuex'
import LinkRefInjectee from '~/mixins/link-ref/LinkRefInjectee'
import businessMixin from '~/mixins/pages/business-mixin'

export default {
  name: 'UserCassette',
  mixins: [LinkRefInjectee, businessMixin],
  props: {
    user: {
      type: Object,
      required: true
    },
    itemNumber: {
      type: Number,
      default: null
    },
    isSkeleton: {
      type: Boolean,
      default: false
    },
    /** 簡略表示 */
    isSimple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linkRefs() {
      const refs = {}
      if (this.linkRef) {
        refs['ref'] = this.linkRef
      }
      if (this.linkRefKind) {
        refs['ref_kind'] = this.linkRefKind
      }
      if (this.linkRefSort) {
        refs['ref_sort'] = this.linkRefSort
      }
      if (this.linkRefCategory) {
        refs['ref_category'] = this.linkRefCategory
      }
      if (this.itemNumber) {
        refs['ref_no'] = this.itemNumber
      }
      return refs
    },
    linkUrl() {
      const routeData = this.$router.resolve({
        path: `/users/${this.user.userId}`,
        query: this.linkRefs
      })
      return this.addQueryToUrlIfBusinessPreview(routeData.href)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-userCassette {
  display: block;
  position: relative;
  width: 231px;
  padding: 12px;
  border: 1px solid $color-gray-200;
  overflow: hidden;
  background-color: $color-white;
  @include link-effect;
}

.c-userCassetteInfo {
  display: flex;
  color: $color-gray-900;
  font-size: 12px;

  &_right {
    margin-left: 8px;
  }

  &_icon {
    flex-basis: 42px;
    width: 42px;
    height: 42px;
    overflow: hidden;

    img {
      border-radius: 50%;
      height: 42px;
      width: 42px;
    }
  }

  &_label {
    display: flex;
    justify-content: center;
    margin-top: 4px;
  }

  &_certificationIcon {
    margin-right: 4px;
    width: 20px;
    overflow: hidden;
  }

  &_labelLevel {
    display: inline-flex;
    width: 20px;
    min-height: 20px;
    align-items: center;
    overflow: hidden;

    img {
      width: 20px;
    }
  }

  &_name {
    font-weight: bold;
  }

  &_occupation {
    margin-top: 4px;
    font-size: 11px;
    line-height: 120%;
    height: 26px;
    overflow: hidden;
  }

  &_rating {
    display: flex;
    align-items: center;
  }
}

.c-userCassetteInfoRating {
  display: flex;
  align-items: center;
  margin-right: 4px;
  color: $ds2-color-star;

  &_star {
    margin-right: 4px;
    font-size: 12px;
  }
}

.c-userCassetteInfoPaidOrderCount {
  color: $color-gray-900;
  font-size: 11px;
}

@media (max-width: breakpoint(ServiceDetail, M)) {
}
</style>
